import { formatDate, SelectItemProps } from '@ui/src';
import { CASP } from '@ui/src/components/transactions-sidepanels/types';
import { PaymentType } from '../../../../store/dictionaries/types';
import { ExternalAccount } from '../types';

import cn from '../styles.module.css';

const formatExternalList = (
  list?: ExternalAccount[],
  paymentTypes?: PaymentType[],
  casp?: CASP[],
  currenciesList?: SelectItemProps[],
): ExternalAccount[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const availablePaymentTypes: string[] = [];

    item?.pspIntegrationPayment?.paymentsTypes?.forEach((type) => {
      if (
        paymentTypes?.find((paymentType) => paymentType.paymentType === type)
      ) {
        availablePaymentTypes.push(
          paymentTypes?.find((paymentType) => paymentType.paymentType === type)
            ?.name as string,
        );
      }
    });

    const currentCurrencies: string[] = [];

    if (item?.currenciesIds?.length) {
      item?.currenciesIds?.forEach((currencyId) => {
        currentCurrencies.push(
          currenciesList?.find((currency) => currency.value === currencyId)
            ?.name as string,
        );
      });
    }

    const render: Record<string, any> = {
      pspPartnerId: <div>{item?.pspPartner?.companyName}</div>,
      accountId: <div>{item?.account?.fullNumber}</div>,
      createdAt: <div>{formatDate(item?.createdAt as string)}</div>,
      caspId: (
        <div>
          {item?.caspId
            ? casp?.find((caspValue) => caspValue?.id === item.caspId)?.name
            : '-'}
        </div>
      ),
      currencyId: (
        <div className={cn.currenciesWrapper}>
          {currentCurrencies?.join(', ') || '-'}
        </div>
      ),
      paymentType: (
        <div className={cn.paymentTypesRow}>
          {availablePaymentTypes?.join(', ') || '-'}
        </div>
      ),
      active: (
        <div className={!item.active ? cn.disabledStatus : ''}>
          {item?.active ? 'Enabled' : 'Disabled'}
        </div>
      ),
      createType: (
        <div>
          {result.createType
            ? `${result.createType.charAt(0)}${result.createType
                .slice(1)
                .toLowerCase()}`
            : ''}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList as ExternalAccount[];
};

export default formatExternalList;
